import React from 'react';
import { EmptyStateProps } from './types';
import { prependLocaleToPath } from 'src/scripts/utils/localization';

const OrderHistoryEmptyState = ({ heading, message, link, cta }: EmptyStateProps) => {
  return (
    <div className="col-12 col-md-9 mt-xl-5">
      {heading && <h3 className="mb-3 text-center order-history-empty-heading">{heading}</h3>}
      <p className="body text-center mb-3" style={{ whiteSpace: 'pre-line' }}>
        {message}
      </p>
      <div className="text-center order-history-empty-cta-wrapper">
        <a href={prependLocaleToPath(link)} className="btn btn-primary order-history-empty-cta">
          {cta}
        </a>
      </div>
    </div>
  );
};

export default OrderHistoryEmptyState;
